export default __webpack_public_path__ + "static/media/wh_ep1_tutorial_008.7b15951a.jpg";